import { isWebPlatform } from './platform';

export const API_URL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000').replace(/\/$/, '');

export const DEBUG_ENABLED = import.meta.env.VITE_ENABLE_DEBUG !== 'false';

/**
 * Whether the world editor can be opened at all.
 *
 * Web only, by design — see `isWebPlatform`. The debug flag stays in front of
 * it so a build can turn the editor off without shipping a different bundle.
 */
export const DEV_MODE_ENABLED = DEBUG_ENABLED && isWebPlatform();

/**
 * How often the age readout refreshes.
 *
 * This is the only thing left that changes with time: with stats gone there is
 * nothing to decay, so there is nothing to poll the server for either.
 */
export const CLOCK_INTERVAL_MS = 30_000;

/** How long a held direction waits before taking the next grid step. */
export const STEP_REPEAT_MS = 160;

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? '';
export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '';
